module.exports = __webpack_public_path__ + "images/b66896b38e5a292e1475ceb8a6305aa8.svg";